<template>
    <v-card>
        <v-card-text class="pa-0">
            <iframe width="100%" height="700" :src=dashboard frameborder="0" style="border:0" allowfullscreen></iframe>
        </v-card-text>
    </v-card>
</template>

<script>

export default {
    name: 'Dashboards',
    computed: {
        dashboard () {
            const currentUserCompany = JSON.parse(localStorage.currentUserCompany)
            return currentUserCompany.client.dashboard
        }
    }
}
</script>
